// extracted by mini-css-extract-plugin
module.exports = {"container":"product_container__3Hqya","itemDiv":"product_itemDiv__1NtTV","unavailable":"product_unavailable__xu0MD"};